import { ChangeDetectionStrategy, Component, HostListener, Input, OnChanges, SimpleChanges } from '@angular/core';
import { StringTransformHelper } from '../../../shared/string-transform.helper';
import { LiveClassDto } from '../../../shared/types/LiveClassDto';

@Component({
  selector: 'lp2-cohort-tile',
  templateUrl: './cohort-tile.component.html',
  styleUrls: ['./cohort-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CohortTileComponent implements OnChanges {
  @Input() public liveClass: LiveClassDto;

  public classTypeTranslationKey: string;
  public classTypeTooltipTranslationKey: string;
  public hovered: boolean = false;

  public ngOnChanges(changes: SimpleChanges): void {
    if ('liveClass' in changes) {
      this.setTranslationKeys();
    }
  }

  private setTranslationKeys() {
    const camelCaseSubType = StringTransformHelper.toCamelCase(this.liveClass.subType);
    this.classTypeTranslationKey = `studybundle.liveClasses.${camelCaseSubType}`;
    this.classTypeTooltipTranslationKey = `studybundle.liveClasses.${camelCaseSubType}Tooltip`;
  }

  @HostListener('mouseenter')
  public onMouseEnter() {
    this.hovered = true;
  }

  @HostListener('mouseleave')
  public onMouseLeave() {
    this.hovered = false;
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/cohort/cohort-tile/cohort-tile.component.ts